import { render, staticRenderFns } from "./AttributesTable.vue?vue&type=template&id=0ce0eed0"
import script from "./AttributesTable.vue?vue&type=script&lang=js"
export * from "./AttributesTable.vue?vue&type=script&lang=js"
import style0 from "./AttributesTable.vue?vue&type=style&index=0&id=0ce0eed0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports